import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-materiel',
  templateUrl: './edit-materiel.component.html',
  styleUrls: ['./edit-materiel.component.css']
})
export class EditMaterielComponent implements OnInit {

  @Input() materiel;
  @Input() fromEcogar;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() customWidth = new EventEmitter<any>();
  
  @ViewChild('msg') msg;
  @ViewChild('logo') logo;
  @ViewChild('confirmEditDate') confirmEditDate;
  
  isType3: Boolean = false;
  isEmpty: Boolean = false;
  isPrestation: Boolean = false;
  loadTable: Boolean = false;
  error = '';
  classPresta: String = 'detailfact ';
  dataClient = [];
  listPays = [];
  listSite = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
  listTypeInstall = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
  listTypeMateriel = [];
  listRemorque = [{ id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' }];
  listPgmEntretien = [{ id: 0, nom: 'Aucun', libelleObjetEntite: 'Aucun' }];
  listSousTypeMateriel = [];
  listMarque = [];
  listTypeEquip = [];
  listSousTypeEquip = [];
  listTypePropriete = [];
  listTypePresta = [];
  listEquipement = [];
  listImmaHisto = [];
  listSiteHisto = [];
  cheminLogo: any = '';
  objFileObject: any = {};
  objSite : any = {}
  listMotorisation = [
    { id: 0, libelleObjetEntite: 'Sans' },
    { id: 1, libelleObjetEntite: 'ES' },
    { id: 2, libelleObjetEntite: 'GO' },
    { id: 3, libelleObjetEntite: 'GPL' },
    { id: 4, libelleObjetEntite: 'GNV' },
    { id: 5, libelleObjetEntite: 'Electrique' },
    { id: 6, libelleObjetEntite: 'EG (Electrique + Gazoil)' },
    { id: 7, libelleObjetEntite: 'EN (Essence + GNV)' },
    { id: 8, libelleObjetEntite: 'Fuel' },
    { id: 9, libelleObjetEntite: 'GH' },
    { id: 10, libelleObjetEntite: 'EE (Essence + Electrique)' },
    { id: 11, libelleObjetEntite: 'B1003' },
  ];
  typeContenant = [];
  listCategorie = [];
  typeDocuments = [];
  deleteElm = [];
  listCouleur = [];
  listGenre = [];
  tempDBGetCamion = [];
  dateCession = new Date();
  dataArticle = [];
  listEntretien = [];

  listIcon = [{
    id: 0, libelle: 'Aucun', libelleObjetEntite: `
  <img src="assets/images/icons/camionDefaut.png" alt="camion" style="height:30px; "> <span> Camion </span>
  ` }];

  societe: any = {};
  paramHolding : any  = {};
  isParametrageCamionHolding : Boolean = false; 
  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.paramHolding = this.common.local.getObject('paramHolding') || {};
    const isParametrageCamion = this.paramHolding['parametrageCamion'] ? this.paramHolding['parametrageCamion'] : false;
    this.isParametrageCamionHolding = isParametrageCamion && this.societe.isAppartientHolding;
    this.getlistMotorisation().then((datas)=>{
      this.searchSite();
      this.sortListMotorisation(this.listMotorisation);
      this.listMotorisation = [{id:0, libelleObjetEntite:"Aucune"},...this.listMotorisation]
      this.searchTypecontenant();
      this.globalSearch().then(() => {
        if (this.materiel['id']) {
          this.getDetail(this.materiel['id']);
        } else {
          this.materiel['isClient'] = true;
          this.materiel['site'] = this.listSite[0];
          this.materiel['objMotorisation'] = this.listMotorisation.find(el=>el.id==0);
          this.materiel['motorisation'] = this.materiel['objMotorisation'].libelleObjetEntite;
          this.materiel['programmeEntretien'] = this.listPgmEntretien[0];
          this.materiel['CamionRemorque'] = this.listRemorque[0];
          this.getListPrestAFaire({ id: 0 });
        }
      });
    })

  }

  returnList() {
    this.hidefunction.emit();
  }

  searchSite() {
    this.listSite = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    const list = this.common.getType('typeSite') || [];
    list.forEach(elt => {
      elt.libelleObjetEntite = elt.libelle || '';
      this.listSite.push(elt);
    });
  }

  save(cession?) {
    // Vérification des champs
    if (!this.materiel['type'] || (this.materiel['type'] && this.materiel['type'].id === 0)) {
      this.common.closeModal();
      this.error = 'Le champs type de matériel est obligatoire.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    this.materiel['prestationAFaire'] = this.listEntretien.length ? this.listEntretien : this.materiel['prestationAFaire'];
    this.materiel['prestationAFaire'].forEach(row => {
      if ((row.nbMoisEntrePrestation === 0 || !row.nbMoisEntrePrestation) &&
      (row.nbJoursEntrePrestation === 0 || !row.nbJoursEntrePrestation)) {
        row.datePrest = '31/12/9999';
      } else {
        if (row.dateDerPrest !== '31/12/9999') {
          row.datePrest  = moment(row.dateDerPrest, 'DD/MM/YYYY').add((row.nbMoisEntrePrestation || 0), 'months');
          row.datePrest  = moment(row.datePrest).add((row.nbJoursEntrePrestation || 0), 'days');
          row.datePrest  = moment(row.datePrest).format('DD/MM/YYYY');
        } else {
          row.datePrest = '31/12/9999';
        }
      }
    });

    this.materiel['idVehiculeElocom'] = this.materiel['idVehiculeElocom'] || '';
    this.materiel['pays'] = this.materiel['pays'] || '';
    this.materiel['categorie'] = this.materiel['categorie'] || '';
    this.materiel['genre'] = this.materiel['genre'] || '';
    this.materiel['numId'] = this.materiel['numId'] || '';

    this.materiel['typeVariantVersion'] = this.materiel['typeVariantVersion'] || '';
    this.materiel['carroserieNat'] = this.materiel['carroserieNat'] || '';
    this.materiel['denominationCle'] = this.materiel['denominationCle'] || '';
    this.materiel['couleur'] = this.materiel['couleur'] || '';
    this.materiel['motorisation'] = this.materiel['motorisation'] || '';
    this.materiel['numeroCarteGrise'] = this.materiel['numeroCarteGrise'] || '';
    this.materiel['immatriculationCertifPrec'] = this.materiel['immatriculationCertifPrec'] || '';
    if (!this.materiel['checkBoxLogo']) {
      this.materiel['nomIconPerso'] = ''
    }

    this.materiel['nomclass'] = 'Camion';
    const param = {
      'servlet': 'DBMAJCamion',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [this.materiel, '' + this.common.user[0]]
    };

    if (this.societe.numParcCamionObligatoire && this.materiel['numParc'] === '') {
      this.error = 'Le champs "Numéro du parc" est obligatoire.';
      this.common.openModal(this.modalService, this.msg);
    } else {
      this.common.post('', { param: param }).then(dt => {
        if (dt.message) {
          this.common.closeModal();
          this.error = dt.message;
          this.common.openModal(this.modalService, this.msg);
        } else if (dt.data === 'ERR_SETTING_TABLE_0') {
          this.common.closeModal();
          this.error = 'Il existe déjà un matériel avec le même nom.';
          this.common.openModal(this.modalService, this.msg);
        } else if (dt.data === 'ERR_RAPPORT_1') {
          this.common.closeModal();
          this.error = 'Un problème est survenu pendant la mise à jour du matériel.';
          this.common.openModal(this.modalService, this.msg);
        } else {
          const id = this.materiel['id'];
          this.common.createLog('15', dt.data, id ? false : true);
          this.materiel['id'] = dt.data;
          this.saveLogo(this.materiel['id']);
          if (!cession) {
            this.returnList();
          } else {
            this.cessionVehicule();
          }
        }
      });
    }
  }

  getDetail(id) {
    const param = {
      'servlet': 'DBGetCamion',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetCamion', '' + id]
    };

    this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.materiel = dt.data[0];
        if (this.materiel['cede']) {
          this.error = 'Le matériel a été cédé. Vous ne pouvez plus le modifier.';
          this.common.openModal(this.modalService, this.msg);
        }
        this.getLogo();
        this.materiel['checkBoxLogo'] = this.materiel['nomIconPerso'] ? true : false;
        this.materiel['site'] = this.materiel['site'] || this.listSite[0];
        this.materiel['type'] = this.materiel['type'] || this.listTypeMateriel[0];
        this.getLibelleContenant(this.materiel['typeContenant']);
        this.materiel['sousTypeCamion'] = this.materiel['sousTypeCamion'] || this.listSousTypeMateriel[0];
        this.materiel['typePropriete'] = this.materiel['typePropriete'] || this.listTypePropriete[0];
        this.materiel['marque'] = this.materiel['marque'] || this.listMarque[0];
        this.materiel['typeEquip'] = this.materiel['typeEquip'] || this.listTypeEquip[0];
        this.materiel['sousTypeEquip'] = this.materiel['sousTypeEquip'] || this.listSousTypeEquip[0];
        this.materiel['CamionRemorque'] = this.materiel['CamionRemorque'] || this.listRemorque[0];
        if (this.materiel['dateEntree']) {
          this.materiel['dateEntree'] = this.materiel['dateEntree'].slice(0, -9);
        }
        if (this.materiel['dateImm']) {
          this.materiel['dateImm'] = this.materiel['dateImm'].slice(0, -9);
        }
        this.getListPrestAFaire(this.materiel['programmeEntretien'] ? this.materiel['programmeEntretien'] : { id: 0 });
        this.listTypeMateriel.forEach(elt => {
          if (this.materiel['type'] && this.materiel['type'].id === elt.id) {
            this.materiel['type'] = elt;
          }
        });
        /*
        this.listTypeMateriel.forEach(elt => {
          if (this.materiel['type'] && this.materiel['type'].id === elt.id) {
            this.materiel['type'] = elt;
          }
        });
        
        this.listSousTypeMateriel.forEach(elt => {
          if (this.materiel['sousTypeCamion'] && this.materiel['sousTypeCamion'].id === elt.id) {
            this.materiel['sousTypeCamion'] = elt;
          }
        });
        */

        if (this.materiel['type'] && this.materiel['type'].id) {
          this.searchSousTypeMateriel(this.materiel['type'].id).then(() => { });
        }

        this.listTypePropriete.forEach(elt => {
          if (this.materiel['typePropriete'] && this.materiel['typePropriete'].id === elt.id) {
            this.materiel['typePropriete'] = elt;
          }
        });
        this.listMarque.forEach(elt => {
          if (this.materiel['marque'] && this.materiel['marque'].id === elt.id) {
            this.materiel['marque'] = elt;
          }
        });
        this.listTypeEquip.forEach(elt => {
          if (this.materiel['typeEquip'] && this.materiel['typeEquip'].id === elt.id) {
            this.materiel['typeEquip'] = elt;
          }
        });

        this.listMotorisation.forEach(element => {
          if (element.libelleObjetEntite === this.materiel['motorisation']) {
            this.materiel['objMotorisation'] = element;
          }
        });

        /*
        this.listSousTypeEquip.forEach(elt => {
          if (this.materiel['sousTypeEquip'] && this.materiel['sousTypeEquip'].id === elt.id) {
            this.materiel['sousTypeEquip'] = elt;
          }
        });
        */
        if (this.materiel['typeEquip'] && this.materiel['typeEquip'].id) {
          this.searchSousTypeEquip(this.materiel['typeEquip'].id).then(() => { });
        }
  
        const dateImmatriculationModel = this.materiel.dateImmatriculation ?
        moment(this.materiel.dateImmatriculation, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') :
        '31/12/9999';
        const dateImmatriculationPrecedenteModel = this.materiel.dateImmatriculationPrecedente ?
        moment(this.materiel.dateImmatriculationPrecedente, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') :
        '31/12/9999';

        this.materiel.dateImmatriculationModel = this.common.parseDate(dateImmatriculationModel);
        this.materiel.dateImmatriculationPrecedenteModel = this.common.parseDate(dateImmatriculationPrecedenteModel);

       
      }
    });
  }

  getLibelleContenant(elt) {
    if (elt) {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
    }
  }

  searchTypecontenant() {
    this.typeContenant = [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? (elt.uniteCont.libelle || '') : '');
      this.typeContenant.push(elt);
    });
  }

  globalSearch() {
    return this.searchTypeMateriel().then(() => {
      // return this.searchSousTypeMateriel(0).then(() => {
      return this.searchTypeEquip().then(() => {
        return this.searchMarque().then(() => {
          // return this.searchSousTypeEquip(0).then(() => {
          return this.searchTypePropriete().then(() => {
            return this.searchGenre().then(() => {
              return this.searchPgmEntretien();
            });
          });
          // });
        });
      });
      // });
    });
  }

  searchTypeMateriel() {
    const param = {
      'servlet': 'DBGetListTypeCamion',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': [
        'DBGetListTypeCamion'
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        const data = this.common.arrayToObjet(datas.data);
        this.listTypeMateriel = [...this.listTypeMateriel, ...data];
        this.listTypeMateriel.forEach(elt => elt.libelleObjetEntite = elt.libelle);
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchPgmEntretien() {
    const param = {
      'servlet': 'DBGestionProgrammeEntretien',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        // const data = this.common.arrayToObjet(datas.data);
        this.listPgmEntretien = [...this.listPgmEntretien, ...datas.data];
        // this.listPgmEntretien.forEach(elt => elt.libelleObjetEntite = elt.libelle);
        // console.log(this.listPgmEntretien);
        return this.listTypePrestation();
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchSousTypeMateriel(id) {
    console.log('calling searchSousTypeMateriel(' + id + ')');
    const param = {
      'servlet': 'DBGestionSousTypeCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_TYPE_CAMION': {
          'typeParam': 'int',
          'valeur': id
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      // console.log(datas);
      if (datas.data) {
        this.listSousTypeMateriel = datas.data || [];

        if (!this.materiel.sousTypeCamion || (this.materiel.sousTypeCamion && !this.materiel.sousTypeCamion.id)) {
          if (this.listSousTypeMateriel.length) {
            this.materiel.sousTypeCamion = this.listSousTypeMateriel[0];
          } else {
            this.materiel.sousTypeCamion = { id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' };
          }
        }

        this.listSousTypeMateriel.forEach(elt => {
          elt.libelleObjetEntite = elt.libelle;
          if (this.materiel.sousTypeCamion && this.materiel.sousTypeCamion.id && this.materiel.sousTypeCamion.id === elt.id) {
            this.materiel.sousTypeCamion = elt;
          }
        });

      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchMarque() {
    const param = {
      'servlet': 'DBGetListMarqueCamion',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': [
        ''
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listMarque = [...this.listMarque, ...datas.data];
        this.listMarque.forEach(elt => elt.libelleObjetEntite = elt.nom);
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchTypeEquip() {
    const param = {
      'servlet': 'DBGestionSousTypeEquipement',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listTypeEquip = [...this.listTypeEquip, ...datas.data];
        this.listTypeEquip.forEach(elt => elt.libelleObjetEntite = elt.libelle);
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchSousTypeEquip(id) {
    console.log('calling searchSousTypeEquip(' + id + ')');
    const param = {
      'servlet': 'DBGestionSousTypeEquipement',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_TYPE_EQUIPEMENT': {
          'typeParam': 'int',
          'valeur': id || 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listSousTypeEquip = datas.data || [];

        if (!this.materiel.sousTypeEquip || (this.materiel.sousTypeEquip && !this.materiel.sousTypeEquip.id)) {
          if (this.listSousTypeEquip.length) {
            this.materiel.sousTypeEquip = this.listSousTypeEquip[0];
          } else {
            this.materiel.sousTypeEquip = { id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' };
          }
        }

        this.listSousTypeEquip.forEach(elt => {
          elt.libelleObjetEntite = elt.libelle;
          if (this.materiel.sousTypeEquip && this.materiel.sousTypeEquip.id && this.materiel.sousTypeEquip.id === elt.id) {
            this.materiel.sousTypeEquip = elt;
          }
        });
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchTypePropriete() {
    const param = {
      'servlet': 'DBGestionTypePropriete',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listTypePropriete = [...this.listTypePropriete, ...datas.data];
        this.listTypePropriete.forEach(elt => elt.libelleObjetEntite = elt.libelle);
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchGenre() {
    const param = {
      'servlet': 'DBGetCamion',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetCamion', '0', 'true']
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.tempDBGetCamion = datas.data;
        this.refreshData();
        /*if (datas.data[0]) {
          datas.data[0].forEach((elt, index) => {
            this.listCategorie.push({id: index, libelleObjetEntite: elt || ''});
          });
        }

        if (datas.data[1]) {
          datas.data[1].forEach((elt, index) => {
            this.listGenre.push({id: index, libelleObjetEntite: elt || ''});
          });
        }

        if (datas.data[2]) {
          datas.data[2].forEach((elt, index) => {
            this.listCouleur.push({id: index, libelleObjetEntite: elt || ''});
          });
        }*/
        // list => index 1 : genre (champ editable), index 2 : couleur (champ editable)
        // index 0 : catégorie  (champ editable)
        // this.listMarque = [...this.listMarque, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  refreshData() {
    if (this.tempDBGetCamion[0]) {
      this.tempDBGetCamion[0].forEach((elt, index) => {
        this.listCategorie.push({ id: index, libelleObjetEntite: (elt || ' ') });
      });
    }

    if (this.tempDBGetCamion[1]) {
      this.tempDBGetCamion[1].forEach((elt, index) => {
        this.listGenre.push({ id: index, libelleObjetEntite: (elt || ' ') });
      });
    }

    if (this.tempDBGetCamion[2]) {
      this.tempDBGetCamion[2].forEach((elt, index) => {
        this.listCouleur.push({ id: index, libelleObjetEntite: (elt || ' ') });
      });
    }
  }

  searchRemorque(event) {
    this.listRemorque = [{ id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' }];
    const param = {
      'servlet': 'DBGestionCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CRITERE': event || '',
        'CLEF_SITE': '' + this.common.user[2],
        'DATE': {
          'typeParam': 'date',
          'valeur': moment().format('DD/MM/YYYY')
        },
        'PERIODE': null
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listRemorque = [...this.listRemorque, ...datas.data];
        this.listRemorque.forEach(elt => elt.libelleObjetEntite = elt['immatriculation'] || elt.libelleObjetEntite);
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  cessionVehicule() {
    const param = {
      'servlet': 'DBCessionVehicule',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id']
        },
        'CRITERE': event || '',
        'DATE_CESSION': {
          'typeParam': 'date',
          'valeur': this.materiel['dateCession']
        },
        'MOTIF_CESSION': this.materiel['motifCession']
      }
    };
    this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.returnList();
      }
    });
  }

  changeChampRecherche(event, element) {
    this.materiel[element] = event;
    this.refreshData();
  }

  changeDate(event, element) {
    if (moment(event).isValid()) {
      this.materiel[element] = moment(event).format('DD/MM/YYYY');
      // console.log(this.materiel[element]);
    } else {
      this.materiel[element] = moment().format('DD/MM/YYYY');
      // console.log(this.materiel[element]);
    }

  }

  

  setValue(event, row) {
    row.id = event.id;
    row.libelle = event.libelleObjetEntite;
  }

  searchArticle(event) {
    this.dataArticle = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    const param = 40;

    return this.common.appelComboK3Fct(param, event, [{
      nom: 'CLEF_FAMILLE_ARTICLE', valeur: {
        'typeParam': 'int',
        'valeur': 5
      }
    }]).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = [...this.dataArticle, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  deleteLigne(row) {
    const temp = this.materiel['prestationAssociees'].filter(elt => elt !== row);
    this.materiel['prestationAssociees'] = temp;
  }

  addLigne() {
    this.materiel['prestationAssociees'] = this.materiel['prestationAssociees'] || [];
    this.materiel['prestationAssociees'].push({
      id: '0'
    });
    this.materiel['prestationAssociees'] = [...this.materiel['prestationAssociees']];
    const length = this.materiel['prestationAssociees'].length - 1;
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);
  }

  showPrestAssociees() {
    this.isPrestation = !this.isPrestation;
  }

  getLogo() {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'TABLE': 'camions',
        'COLONNE': 'nomIconPerso',
        'COLONNE_CLEF': 'clefCamion',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.materiel['id']
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      this.materiel['logo'] = datas.data;
      this.materiel['fichierLogo'] = {};
    });
  }

  revertLogo() {
    this.materiel['nomIconPerso'] = '';
  }

  saveLogo(id) {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'TABLE': 'camions',
        'COLONNE': 'nomIconPerso',
        'COLONNE_CLEF': 'clefCamion',
        'CLEF': {
          'typeParam': 'int',
          'valeur': id
        },
        'FICHIER': this.materiel['fichier']
      }
    };
    if (this.materiel['fichier']) {
      return this.common.post('', { param: param });
    }
  }

  openLogo() {
    if (this.materiel['logo']) {
      this.cheminLogo = this.materiel['logo'].NOM_FICHIER !== '' ? this.common.intercept(this.materiel['logo'].NOM_FICHIER) : '';
    }
    this.common.openModal(this.modalService, this.logo);
  }

  getNameFile(event) {
    const ctrl = this;
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImg(file.name)) {
        this.error = this.common.msgErreurExtensionFichier;
        this.common.openModal(this.modalService, this.msg);
        return;
    }          
    
    ctrl.objFileObject['nomFichier'] = file.name;
    ctrl.objFileObject['nomclass'] = 'FileObject';
    const fileReader = new FileReader();
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      ctrl.objFileObject['contentBase64'] = base64[1];
      ctrl.cheminLogo = fileReader.result;
    };
    fileReader.readAsDataURL(file);
  }

  validerLogo() {
    this.materiel['fichier'] = this.objFileObject;
  }

  getListPrestAFaire(event) {
    this.listEntretien = [];
    if (event.id !== 0) {
      const param = {
        'servlet': 'DBGestionProgrammeEntretien',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 1
          },
          'CLEF_PROGRAMME': {
            'typeParam': 'int',
            'valeur': event.id
          }
        }
      };
      return this.common.post('', { param: param }).then(datas => {
        // $('#autocomplete').trigger('click');
        if (datas.data) {
          const data = datas.data || {};
          this.listTypePresta = this.listTypePresta || [];
          this.listTypePresta.forEach(elt => {
            data.listeTypesPrestationCamion = data.listeTypesPrestationCamion || [];
            data.listeTypesPrestationCamion.forEach(elm => {
              if (elt.id === elm.id) {
                const element = this.getValeur(elt);
                const objet = element ? element :
                  {
                    typePrestation: elt,
                    dateDerPrest: '31/12/9999',
                    dateModel: this.common.parseDate('31/12/9999')
                  };
                this.listEntretien.push(objet);
              }
            });
          });

          this.listEntretien = [...this.listEntretien]
        } else {
          if (datas.message) {
            if (datas.message.includes('Utilisateur non authentifié')) {
              this.common.removeConnection();
            }
          }
        }
      });
    } else {
      this.listTypePresta.forEach(elt => {
        const element = this.getValeur(elt);
        const objet = element ? element :
          {
            typePrestation: elt,
            dateDerPrest: '31/12/9999',
            dateModel: this.common.parseDate('31/12/9999')
          };
        this.listEntretien.push(objet);
      });
    }
  }

  getValeur(elt) {
    let exist: any = false;
    this.materiel['prestationAFaire'] = this.materiel['prestationAFaire'] || [];
    this.materiel['prestationAFaire'].forEach(cam => {
      if (cam.dateDerPrest && cam.dateDerPrest !== '31/12/9999') {
        cam['mettreReadOnlyDateDerPrest'] = true;
      }
      cam.dateDerPrest = cam.dateDerPrest ?
        moment(cam.dateDerPrest, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') :
        '31/12/9999';
      cam.dateModel = this.common.parseDate(cam.dateDerPrest);

      if (cam.typePrestation && cam.typePrestation.id === elt.id) {
        exist = cam;
      }
    });
    return exist;
  }

  listTypePrestation() {
    // appel volohany : si aucun tous sinon foreach listtypePrestation
    const param = {
      'servlet': 'DBGestionTypePrestCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listTypePresta = [...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  getListHistoSite() {
    this.loadTable = true;
    const param = {
      'servlet': 'DBGetHistoModifCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'HISTORIQUE': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id'] || 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      this.loadTable = false;
      if (datas.data) {
        this.listSiteHisto = [...datas.data];
        this.listSiteHisto.forEach(elt => {
          elt.date = elt.date ? moment(elt.date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
          elt.dateEdit = this.common.parseDate(elt.date);
        });
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  saveHistoSite(row) {
    this.loadTable = true;
    row.edit = false;
    let objSiteHisto = row;
    objSiteHisto['nomclass'] = 'HistoSiteCamion';
    const param = {
      'servlet': 'DBGetHistoModifCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'HISTORIQUE': {
          'typeParam': 'int',
          'valeur': 2
        },
        'HISTO_SITE' : objSiteHisto
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      this.loadTable = false;
      this.getListHistoSite()
    });
  }


  getListHistoImma() {
    this.loadTable = true;
    const param = {
      'servlet': 'DBGetHistoModifCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'HISTORIQUE': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id'] || 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      this.loadTable = false;
      if (datas.data) {
        this.listImmaHisto = [...datas.data];
        this.listImmaHisto.forEach(elt => {
          elt.date = elt.date ? moment(elt.date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
        });
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  getListEquipement() {
    this.loadTable = true;
    const param = {
      'servlet': 'DBGestionEquipementCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id'] || 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      this.loadTable = false;
      if (datas.data) {
        this.listEquipement = [...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  deleteFicheControle() {
    this.materiel['nomFichierFicheControle'] = '';
    const param = {
      'servlet': 'DBGestionFichierFicheControleCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id']
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.message) {
        if (datas.message.includes('Utilisateur non authentifié')) {
          this.common.removeConnection();
        }
      }
    });
  }

  openFicheControle() {
    const param = {
      'servlet': 'DBGestionFichierFicheControleCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id']
        },
        'FROM_ANGULAR': 'true'
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.message) {
        if (datas.message.includes('Utilisateur non authentifié')) {
          this.common.removeConnection();
        }
      } else {
        this.common.openFile(datas.data[0]);
      }
    });
  }

  getFicheControle(event) {
    const ctrl = this;
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImgEtTexte(file.name)) {
        this.error = this.common.msgErreurExtensionFichier;
        this.common.openModal(this.modalService, this.msg);
        return;
    }          
    
    const nomFichier = file.name;
    this.materiel['nomFichierFicheControle'] = nomFichier;
    const fileReader = new FileReader();
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      const contentBase64 = base64[1];
      ctrl.saveFichecontrole(nomFichier, contentBase64);
    };
    fileReader.readAsDataURL(file);
  }

  saveFichecontrole(nom, contenu) {
    const param = {
      'servlet': 'DBGestionFichierFicheControleCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': this.materiel['id']
        },
        'NOM_FICHIER': nom,
        'CONTENU': contenu,
        'FROM_ANGULAR': 'true'
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.message) {
        if (datas.message.includes('Utilisateur non authentifié')) {
          this.common.removeConnection();
        }
      }
    });
  }

  changeDateModel(event, row, type) {
    if (moment(event).isValid()) {
      row[type] = moment(event).format('DD/MM/YYYY');
    } else {
      row[type] = !event ? moment().format('DD/MM/YYYY') : '';
    }
  }
  

  onActivate(event) {
  }

  changeDateContrat(event, type, row) {
    if (event && moment(event).isValid()) {
      const date = moment(event, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
      this.common.parseDate(date)
      row[type] = this.common.parseDate(date);
      row['date'] = date;
    } else {
      row[type] = '';
    }
  }

  showInputDate(index?,row?) {
   row.edit = true;
  }
   
  confirmSaveHistoSite(row) {
    this.objSite = row;
    this.common.openModal(this.modalService,this.confirmEditDate)
  }

  cancel() {
    // this.loadingIndicator = true;
    this.getListHistoSite();
  }

  sortListMotorisation(list) {
    list.sort(function (a, b) {
      const alc = a.libelleObjetEntite.toLowerCase();
      const blc = b.libelleObjetEntite.toLowerCase();
      return alc > blc ? 1 : alc < blc ? -1 : 0;
    });
    return list;
  }

  onTabChange(event: any) {
    if (this.fromEcogar && event.nextId == "tab-entretien") {
      this.customWidth.emit(true);
    } else {
      this.customWidth.emit(false);

    }

  }


  getlistMotorisation() {
    const param = {
      'servlet': 'DBGestionMotorisation',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        console.log('sssss')
        this.listMotorisation =   datas.data || [];
      } else {
        if (datas.message) {
          this.common.closeModal();
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

}
